import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { State, SortParamsArg } from 'models';
import { setBankAccountsSortParams } from 'store/bank-accounts/action-creators';
import { fetchBankAccounts } from 'store/bank-accounts/actions';
import {
  selectSortParams,
  getBankAccounts,
} from 'store/bank-accounts/selectors';
import { bankAccountsTableCells } from 'configs';

import { BankAccountsDetails } from 'components';

const BankAccounts = () => {
  const dispatch = useDispatch();
  const { coopId, sortParams, bankAccounts, loading, error } = useSelector(
    (state: State) => ({
      coopId: state.settings.current_cooperative,
      sortParams: selectSortParams(state),
      bankAccounts: getBankAccounts(state),
      loading: state.bankAccounts.loading,
      error: state.bankAccounts.error,
    })
  );

  useEffect(() => {
    if (coopId) {
      dispatch(fetchBankAccounts(coopId));
    }
  }, [coopId, dispatch]);

  const handleChangeSortParams = useCallback(
    (params: SortParamsArg) => {
      dispatch(setBankAccountsSortParams(params));
    },
    [dispatch]
  );

  return (
    <BankAccountsDetails
      bankAccounts={bankAccounts}
      handleChangeSortParams={handleChangeSortParams}
      sortParams={sortParams}
      loading={loading}
      error={error}
      tableCells={bankAccountsTableCells}
      title={'Pankkitilit'}
    />
  );
};

export default BankAccounts;
